module.exports = __webpack_public_path__ + "img/step1.a9e2a31a.png";